module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-600.2bc320a6.eot";